import type { JSX } from 'react';
import type { VoiceSnapshot } from '../voice/controller';
import { useT } from '../i18n/useT';

export function ListeningIndicator({ state, onCancel }: { state: VoiceSnapshot; onCancel: () => void }): JSX.Element | null {
  const t = useT();
  if (state.status === 'idle') return null;
  if (state.status === 'error') {
    return (
      <div className="listening error" role="alert">
        <span>
          {t('voiceError')}: {state.error}
        </span>
        <button type="button" className="btn btn-small" onClick={onCancel}>
          {t('close')}
        </button>
      </div>
    );
  }
  const label = state.status === 'requestingMic' ? t('requestingMic') : state.status === 'connecting' ? t('connecting') : state.status === 'finalizing' ? t('finalizing') : t('listening');
  const seconds = (state.elapsedMs / 1000).toFixed(1);
  const pct = Math.min(100, Math.round(Math.sqrt(state.level) * 160));
  return (
    <div className={`listening ${state.status}`} role="status" aria-live="polite" data-testid="listening-indicator">
      <span className="rec-dot" aria-hidden="true" />
      <span className="listening-label">{label}</span>
      {state.status === 'listening' ? (
        <>
          <span className="level" aria-label="Microphone level">
            <span className="level-fill" style={{ width: `${pct}%` }} />
          </span>
          <span className="listening-seconds">{seconds}s</span>
        </>
      ) : null}
      {state.language ? <span className="chip chip-muted">{state.language}</span> : null}
      {state.partial ? (
        <span className="hearing">
          {t('hearing')} <em>{state.partial}</em>
        </span>
      ) : null}
      <span className="muted small">{t('escCancels')}</span>
    </div>
  );
}
